<template>
 <div class="md-layout">
      <!-- Filter Section Start-->
      <div
        class="md-layout-item md-small-size-100 md-size-50"
      >
        <md-field>
          <label>Enter Ref</label>
          <md-input type="text" v-model.trim="query.ref"></md-input>
          <!-- <md-icon>search</md-icon> -->
        </md-field>
      </div>

      <!-- Dropdown Filter -->
      <div class="md-layout-item md-small-size-100 md-size-50" >
        <md-field>
          <md-select v-model="dateFilter">
            <md-option value="ALL">All Time</md-option>
            <md-option value="DAY">Last 24 Hours</md-option>

            <md-option value="MONTH">Last 30 Days</md-option>
            <md-option value="YEAR">Last 12 Months</md-option>
            <md-option value="CUSTOM">Custom</md-option>
          </md-select>
        </md-field>
      </div>

        <div
        class="md-layout-item md-small-size-100 md-size-25"
        v-if="showDatePicker"
      >
        <md-datepicker md-immediately v-model="query.start">
          <label>Date From</label>
        </md-datepicker>
      </div>

      <div
        class="md-layout-item md-small-size-100 md-size-25"
        v-if="showDatePicker"
      >
        <md-datepicker md-immediately v-model="query.end">
          <label>Date To</label>
        </md-datepicker>
      </div>

      <div class="md-layout-item md-small-size-100 md-size-33">
        <md-button class="md-raised md-success" @click="filter()"
          >Filter</md-button
        >
        <md-button class="md-raised md-danger" @click="reset()"
          >Reset</md-button
        >
      </div>

    </div>
</template>

<script>
import moment from 'moment';

export default {
  watch: {
    dateFilter(view) {
      this.getDate(view);
      // if (view === 'CUSTOM') {
      //   return;
      // }
      // this.filter();
    },
  },
  data() {
    return {
      query: {
        start: null,
        end: null,
        ref: '',
        order: JSON.stringify([['created_at', 'DESC']]),
        get created_at() {
          if (this.start && this.end) {
            this.end.setHours(23);
            this.end.setMinutes(59);
            this.end.setSeconds(59);

            return {
              $between: [this.start.toString(), this.end.toString()],
            };
          }

          return { $between: [this.start, this.end] };
        },
      },
      showDatePicker: false,
      dateFilter: 'DAY',
    };
  },
  methods: {
    reset() {
      this.dateFilter = 'ALL';
      this.$emit('reset');
    },
    filter() {
      this.$emit('filter', this.query);
    },

    getDate(view) {
      let from = new Date();
      let to = new Date();

      switch (view) {
        case 'DAY':
          from = moment(from)
            .subtract(1, 'day')
            .utc()
            .toDate();
          to = moment(to)
            .utc()
            .toDate();
          break;
        case 'MONTH':
          from = moment(from)
            .subtract(1, 'month')
            .utc()
            .toDate();
          to = moment(to)
            .utc()
            .toDate();
          break;
        case 'YEAR':
          from = moment(from)
            .subtract(1, 'year')
            .utc()
            .toDate();
          to = moment(to)
            .utc()
            .toDate();
          break;
        case 'CUSTOM':
          this.showDatePicker = true;
          break;
        default:
          from = null;
          to = null;
          this.showDatePicker = false;
          break;
      }

      this.query.start = from;
      this.query.end = to;

      this.emit('dateFilter', this.dateFilter);
    },
  },
};
</script>
